import {FlexiButton,} from '@flexinet/ui-components';

import {useDeleteAccountMutation} from '../hooks/useAccountsQuery';
import {useAccountsSelection} from "../hooks/useAccountsSelection.ts";
import {AiOutlineDelete} from "react-icons/ai";


export const RemoveRecordButton = () => {

    // FNP-377: the admin Remove button now invokes the canonical deleteAccount
    // soft-delete pipeline (same path portal users hit), so the row actually
    // flips to PENDING_DELETION + emits the workflows-api event. Previously
    // wired to removeAccount, which only emitted the event without touching DDB.
    const deleteAccountMutation = useDeleteAccountMutation();

    const {
        selection,
        handleClearSelection,
    } = useAccountsSelection();

    const recordIds = Object.keys(selection).filter(id => selection[id] === true);
    const disabled = recordIds.length === 0;

    const handleRemove = async () => {
        for (const id of recordIds) {
            await deleteAccountMutation.mutateAsync(id);
        }
        handleClearSelection();
    };

    return (<FlexiButton
        leftSection={<AiOutlineDelete/>}
        disabled={disabled}
        onClick={handleRemove}
    >Remove</FlexiButton>);

};
